export const TabValues = {
  HOME_TAB: 'Home',
  SERVICE_AND_FEES_TAB: 'Service & Fees',
  ABOUT_ME_TAB: 'About Me',
  INSPECTION_SAMPLES_TAB: 'Inspection Report Samples'
  // HONOR_GUARANTEE_TAB: 'Honor Guarantee',
};
